import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Radio from '../radio';
import HelpText from '../__partials/help-text';
import giveWarning from '../../__utils/warning';

const RadioGroup = ({
  children,
  header,
  name,
  valueChecked,
  required,
  disabled,
  hasError,
  helpText,
  hideHeader,
  hasDivider,
  onChange,
  className,
  qaId,
}) => {
  const formItemClasses = classNames('uni-form__item', 'l-grid__item', {
    'uni-form__item--is-error': hasError,
    'uni-form__item--is-disabled': disabled,
    'uni-form__item--has-divider': hasDivider,
    [className]: className,
  });

  const options = React.Children.map(children, option => {
    if (option.props.checked) {
      giveWarning('To set the checked radio, use RadioGroups `valueChecked`.');
    }

    return (
      <Radio
        {...option.props}
        name={name}
        checked={valueChecked === option.props.value}
        disabled={disabled ? disabled : option.props.disabled}
        onChange={onChange}
      />
    );
  });

  return (
    <div className={formItemClasses} data-qa-id={qaId}>
      <fieldset className="uni-form__radio-group">
        {hideHeader ? null : (
          <h4 className="uni-form__radio-header">
            {header}
            {required ? <span className="uni-form__required" /> : null}
          </h4>
        )}
        {options}
      </fieldset>
      {helpText ? <HelpText text={helpText} /> : null}
    </div>
  );
};

RadioGroup.propTypes = {
  children: PropTypes.node,
  header: PropTypes.string,
  name: PropTypes.string,
  valueChecked: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  hasError: PropTypes.bool,
  helpText: PropTypes.string,
  hideHeader: PropTypes.bool,
  hasDivider: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
  qaId: PropTypes.string,
};

RadioGroup.defaultProps = {
  required: false,
  disabled: false,
  hideHeader: false,
  hasDivider: false,
  onChange: () => { },
};

export default RadioGroup;



// WEBPACK FOOTER //
// ./src/forms/radio-group/index.jsx